var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNorthKorea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_872)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9997 40C31.0454 40 39.9997 31.0457 39.9997 20C39.9997 8.9543 31.0454 0 19.9997 0C8.954 0 -0.000305176 8.9543 -0.000305176 20C-0.000305176 31.0457 8.954 40 19.9997 40Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 0C13.9383 0 8.50678 2.69719 4.83905 6.95648H35.161C31.4933 2.69719 26.0619 0 20.0001 0V0Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1611 33.0435H4.83905C8.50678 37.3028 13.9383 40 20.0001 40C26.0619 40 31.4933 37.3028 35.1611 33.0435Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0645 9.56519H2.93541C1.07377 12.6031 -6.10352e-05 16.176 -6.10352e-05 20C-6.10352e-05 23.8239 1.07377 27.3969 2.93541 30.4347H37.0645C38.9261 27.3969 39.9999 23.8239 39.9999 20C39.9999 16.176 38.9261 12.6031 37.0645 9.56519Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3043 27.6956C16.5545 27.6956 20 24.2502 20 20C20 15.7498 16.5545 12.3044 12.3043 12.3044C8.05415 12.3044 4.6087 15.7498 4.6087 20C4.6087 24.2502 8.05415 27.6956 12.3043 27.6956Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3043 12.3044L14.0309 17.6185H19.6276L15.0982 20.9031L16.8383 26.2331L12.3043 22.9329L7.77709 26.2269L9.51038 20.9031L4.98499 17.6185H10.5776L12.3043 12.3044Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_872"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNorthKorea);
export default __webpack_public_path__ + "static/media/north_korea.7b473eecaa2c841acfb170f40f0faeeb.svg";
export { ForwardRef as ReactComponent };